export default __webpack_public_path__ + "static/media/arrow-small-caret-gray.9bcdc3e8.svg";